import React from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { formatCurrency } from '../utils/formatCurrency';
export function Money({ amount, minimumFractionDigits = 0, maximumFractionDigits = 0, }) {
    var _a, _b;
    const { currentContext } = useGlobalContext();
    const cultureCodeCombined = (_a = currentContext.cultureCode) !== null && _a !== void 0 ? _a : 'en-gb';
    const currencyCodeCombined = (_b = currentContext.currencyCode) !== null && _b !== void 0 ? _b : 'GBP';
    if (amount == null) {
        return null;
    }
    return (React.createElement(React.Fragment, null, formatCurrency({
        amount,
        minimumFractionDigits,
        maximumFractionDigits,
        cultureCode: cultureCodeCombined,
        currencyCode: currencyCodeCombined,
    })));
}
